import { AxiosError } from 'axios';
import { useCustomMutation } from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import { POST_ACCESS_ARRANGEMENT_REPORT } from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PostGenerateReportRequest {
  startDate: string;
  endDate: string;
}

// =============================================================================
// Mutation
// =============================================================================

interface Input {
  onSuccess?: (res: any) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostGenerateReport = ({ onSuccess, onError }: Input = {}) => {
  const postGenerateReport = async (reqBody: PostGenerateReportRequest) => {
    const res = await axiosClient.post(POST_ACCESS_ARRANGEMENT_REPORT, reqBody);

    return res.data;
  };

  return useCustomMutation(postGenerateReport, {
    onSuccess,
    onError,
  });
};
